// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  margin: 0 auto;
}

.video-player__play-btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-player__play-btn svg,
.video-player__play-btn img {
  flex: 0 0 auto;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/video-player/video-player.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/shared/video-player/video-player.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,cAAA;ACCF;;ADGE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACAJ;ADEI;;EAEE,cAAA;EACA,eAAA;ACAN","sourcesContent":[":host {\r\n  display: block;\r\n  margin: 0 auto;\r\n}\r\n\r\n.video-player {\r\n  &__play-btn {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    svg ,\r\n    img {\r\n      flex: 0 0 auto;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n}\r\n",":host {\n  display: block;\n  margin: 0 auto;\n}\n\n.video-player__play-btn {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.video-player__play-btn svg,\n.video-player__play-btn img {\n  flex: 0 0 auto;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
